class FreeGift extends HTMLElement {
  connectedCallback() {
    this.#initializeComponent();
  }

  #initializeComponent() {
    this.#setupEventListeners();
    this.#updateDisplayStyle();
  }

  #setupEventListeners() {}

  #updateDisplayStyle() {
    const isEligibleCountry = !Shopify.currentCountry || ['US', 'CA'].includes(Shopify.currentCountry.code);
    this.style.display = isEligibleCountry ? 'flex' : 'none';
  }
}

customElements.define('free-gift', FreeGift);
